import { graphql } from "@/gql";

export const DeleteNoteMutation = graphql(/* GraphQL */ `
  mutation DeleteNoteMutation ($input: DeleteNoteInput!) {
    deleteNote(input: $input) {
      id
    }
  }
`)
